export default function calculateDueDate(now: Date, paymentTypeId?: string): Date {
  // IDs taken from old NetSuite integration.
  // TODO: Can we load these values from the DB somehow? I'd prefer not to
  // hardcode these values.
  const paymentIsImmediatelyChargable =
    paymentTypeId !== undefined ? ['0', '1', '3', '10'].includes(paymentTypeId) : false;

  const dueDate = new Date(now);

  if (paymentIsImmediatelyChargable) {
    // Set due date to 1 week from now. This will correctly overflow into the
    // next month if the current date is less than one week from the end of the
    // month, per ECMA-262.
    dueDate.setDate(dueDate.getDate() + 7);
  } else {
    // set due date to next month, plus one month so that setting the day to 0
    // in the next step underflows us to the correct value
    dueDate.setMonth(dueDate.getMonth() + 2);
    // set date to the last day of the previous month (note: per ECMA-262, the
    // literal value 0 references the last day of the previous month, so setting
    // the date to 0 when the current month is June will set the date to May
    // 31st)
    dueDate.setDate(0);
  }

  return dueDate;
}
